// const baseUrl = process.env.PUBLIC_URL
// export const default_skin = "6"

// export const popupType = {
//     DELETE: "DELETE",
//     LOGOUT: "LOGOUT"
// }

// export const formType = {
//     LOGIN_CANDIDATE: "LOGIN_CANDIDATE",
//     LOGIN_EMPLOYER: "LOGIN_EMPLOYER"
// }

// export function publicUrlFor(path) {
//     return baseUrl + "/assets/" + path;
// }

// export function loadScript(src, fromPublic) {

//     return new Promise(function (resolve, reject) {
//         var script = document.createElement('script');

//         script.src = (
//             fromPublic === undefined ||
//             fromPublic == null ||
//             fromPublic
//         ) ? publicUrlFor(src) : src;

//         script.addEventListener('load', function () {
//             resolve();
//         });
//         script.addEventListener('error', function (e) {
//             reject(e);
//         });
//         document.body.appendChild(script);
//         document.body.removeChild(script);
//     })
// };

// export function setMenuActive(currentpath, path) {
//     return (currentpath === path) ? "active": "";
// }

// export function applyDefaultSkinStyle() {
//     updateSkinStyle(default_skin, true, false);
// }

// export function updateSkinStyle(skin, headerLogoLight, footerLogoLight) {
//     var _skin_style = document.getElementById("skin_style");
//     var _skin_header_logo = document.getElementById("skin_header_logo");
//     var _skin_header_logo_light = document.getElementById("skin_header_logo_light");
//     var _skin_footer_dark_logo = document.getElementById("skin_footer_dark_logo");
//     var _skin_footer_light_logo = document.getElementById("skin_footer_light_logo");
//     var _skin_page_logo = document.getElementById("skin_page_logo");
//     var _skin_maintain_logo = document.getElementById("skin_maintain_logo");
//     var _skin_header_inner_logo_12 = document.getElementById("skin_header_inner_logo_12");
//     var _skin_header_inner_logo_15 = document.getElementById("skin_header_inner_logo_15");
//     const _logo = publicUrlFor('images/skins-logo/logo-skin-' + skin + '.png');
//     const _logo_light = publicUrlFor('images/logo-light-3.png');
//     const _logo_white = publicUrlFor('images/logo-white.png');

//     if (_skin_style)
//         _skin_style.href = publicUrlFor('css/skins-type/skin-' + skin + '.css');

//     if (_skin_header_logo)
//         _skin_header_logo.src = _logo;

//     if (_skin_header_logo_light) // initially light, on switcher change => it should change
//         _skin_header_logo_light.src = headerLogoLight ? _logo_light : _logo;

//     if (_skin_footer_dark_logo)
//         _skin_footer_dark_logo.src = footerLogoLight ? _logo_white : publicUrlFor('images/skins-logo/logo-skin-' + skin + '-ftr.png');

//     if (_skin_footer_light_logo)
//         _skin_footer_light_logo.src = _logo;

//     if (_skin_page_logo)
//         _skin_page_logo.src = _logo;

//     if (_skin_maintain_logo)
//         _skin_maintain_logo.src = publicUrlFor('images/skins-logo/mainten-logo-' + skin + '.png');

//     if (_skin_header_inner_logo_12)
//         _skin_header_inner_logo_12.src = publicUrlFor('images/skins-logo/logo-all.png');

//     if (_skin_header_inner_logo_15)
//         _skin_header_inner_logo_15.src = publicUrlFor('images/skins-logo/logo-white.png');
// }




const baseUrl = process.env.PUBLIC_URL;
const scriptLoadPromises = new Map();
const styleLoadPromises = new Map();

export const default_skin = "6";

export const popupType = {
  DELETE: "DELETE",
  LOGOUT: "LOGOUT",
};

export const formType = {
  LOGIN_CANDIDATE: "LOGIN_CANDIDATE",
  LOGIN_EMPLOYER: "LOGIN_EMPLOYER",
};

export function publicUrlFor(path) {
  return baseUrl + "/assets/" + path;
}

export function loadScript(src, fromPublic) {
  const resolvedSrc =
    fromPublic === undefined || fromPublic === null || fromPublic
      ? publicUrlFor(src)
      : src;

  if (scriptLoadPromises.has(resolvedSrc)) {
    return scriptLoadPromises.get(resolvedSrc);
  }

  const existingScript = Array.from(document.scripts || []).find(
    (script) => typeof script?.src === "string" && script.src === resolvedSrc,
  );

  if (existingScript?.dataset?.loaded === "true") {
    return Promise.resolve();
  }

  const loadPromise = new Promise((resolve, reject) => {
    const script = existingScript || document.createElement("script");

    script.src = resolvedSrc;
    script.async = false;

    const handleLoad = () => {
      script.dataset.loaded = "true";
      resolve();
    };

    const handleError = (error) => {
      scriptLoadPromises.delete(resolvedSrc);
      reject(error);
    };

    script.onload = handleLoad;
    script.onerror = handleError;

    if (!existingScript) {
      document.body.appendChild(script);
    }
  });

  scriptLoadPromises.set(resolvedSrc, loadPromise);
  return loadPromise;
}

export function loadStyle(href, fromPublic = true) {
  const resolvedHref = fromPublic ? publicUrlFor(href) : href;

  if (styleLoadPromises.has(resolvedHref)) {
    return styleLoadPromises.get(resolvedHref);
  }

  const existingLink = Array.from(
    document.querySelectorAll('link[rel="stylesheet"]'),
  ).find((link) => typeof link?.href === "string" && link.href === resolvedHref);

  if (existingLink?.dataset?.loaded === "true") {
    return Promise.resolve();
  }

  const loadPromise = new Promise((resolve, reject) => {
    const link = existingLink || document.createElement("link");

    link.rel = "stylesheet";
    link.href = resolvedHref;

    const handleLoad = () => {
      link.dataset.loaded = "true";
      resolve();
    };

    const handleError = (error) => {
      styleLoadPromises.delete(resolvedHref);
      reject(error);
    };

    link.onload = handleLoad;
    link.onerror = handleError;

    if (!existingLink) {
      document.head.appendChild(link);
    }
  });

  styleLoadPromises.set(resolvedHref, loadPromise);
  return loadPromise;
}

const CUSTOM_JS_GUARD_KEY = "__unicxCustomJsInitialized";
const CUSTOM_JS_PROMISE_KEY = "__unicxCustomJsInitPromise";
const LEGACY_UI_ASSETS_GUARD_KEY = "__unicxLegacyUiAssetsInitialized";
const LEGACY_UI_ASSETS_PROMISE_KEY = "__unicxLegacyUiAssetsInitPromise";

const OPTIONAL_LEGACY_STYLE_ASSETS = [
  "css/magnific-popup.min.css",
  "css/lc_lightbox.css",
  "css/bootstrap-select.min.css",
  "css/dataTables.bootstrap5.min.css",
  "css/select.bootstrap5.min.css",
  "css/dropzone.css",
  "css/scrollbar.css",
  "css/datepicker.css",
  "css/bootstrap-slider.min.css",
];

const OPTIONAL_LEGACY_SCRIPT_ASSETS = [
  "js/magnific-popup.min.js",
  "js/isotope.pkgd.min.js",
  "js/imagesloaded.pkgd.min.js",
  "js/jquery.owl-filter.js",
  "js/theia-sticky-sidebar.js",
  "js/lc_lightbox.lite.js",
  "js/bootstrap-select.min.js",
  "js/jquery.scrollbar.js",
  "js/bootstrap-datepicker.js",
  "js/jquery.dataTables.min.js",
  "js/dataTables.bootstrap5.min.js",
  "js/bootstrap-slider.min.js",
];

export function ensureLegacyUiAssetsLoaded() {
  if (typeof window === "undefined") return Promise.resolve();

  if (window[LEGACY_UI_ASSETS_GUARD_KEY]) return Promise.resolve();
  if (window[LEGACY_UI_ASSETS_PROMISE_KEY]) {
    return window[LEGACY_UI_ASSETS_PROMISE_KEY];
  }

  window[LEGACY_UI_ASSETS_PROMISE_KEY] = (async () => {
    await Promise.all(
      OPTIONAL_LEGACY_STYLE_ASSETS.map((asset) => loadStyle(asset)),
    );

    for (const asset of OPTIONAL_LEGACY_SCRIPT_ASSETS) {
      await loadScript(asset);
    }

    window[LEGACY_UI_ASSETS_GUARD_KEY] = true;
  })().catch((error) => {
    delete window[LEGACY_UI_ASSETS_PROMISE_KEY];
    throw error;
  });

  return window[LEGACY_UI_ASSETS_PROMISE_KEY];
}

export function ensureCustomJsInitialized() {
  if (typeof window === "undefined") return Promise.resolve();

  if (window[CUSTOM_JS_GUARD_KEY]) return Promise.resolve();
  if (window[CUSTOM_JS_PROMISE_KEY]) return window[CUSTOM_JS_PROMISE_KEY];

  window[CUSTOM_JS_PROMISE_KEY] = (async () => {
    await ensureLegacyUiAssetsLoaded();

    const hasCustomScriptTag = Array.from(document.scripts || []).some(
      (script) => typeof script?.src === "string" && script.src.includes("/assets/js/custom.js")
    );

    if (!hasCustomScriptTag) {
      await loadScript("js/custom.js");
    }

    window[CUSTOM_JS_GUARD_KEY] = true;
  })()
    .catch((error) => {
      delete window[CUSTOM_JS_PROMISE_KEY];
      throw error;
    });

  return window[CUSTOM_JS_PROMISE_KEY];
}

export function setMenuActive(currentpath, path) {
  return currentpath === path ? "active" : "";
}

export function applyDefaultSkinStyle() {
  updateSkinStyle(default_skin, true, false);
}

export function updateSkinStyle(skin, headerLogoLight, footerLogoLight) {
  const _skin_style = document.getElementById("skin_style");
  const _skin_header_logo = document.getElementById("skin_header_logo");
  const _skin_header_logo_light = document.getElementById("skin_header_logo_light");
  const _skin_footer_dark_logo = document.getElementById("skin_footer_dark_logo");
  const _skin_footer_light_logo = document.getElementById("skin_footer_light_logo");
  const _skin_page_logo = document.getElementById("skin_page_logo");
  const _skin_maintain_logo = document.getElementById("skin_maintain_logo");
  const _skin_header_inner_logo_12 = document.getElementById("skin_header_inner_logo_12");
  const _skin_header_inner_logo_15 = document.getElementById("skin_header_inner_logo_15");

  const _logo = publicUrlFor(`images/skins-logo/logo-skin-${skin}.png`);
  const _logo_light = publicUrlFor("images/logo-light-3.png");
  const _logo_white = publicUrlFor("images/logo-white.png");

  if (_skin_style)
    _skin_style.href = publicUrlFor(`css/skins-type/skin-${skin}.css`);

  if (_skin_header_logo) _skin_header_logo.src = _logo;

  if (_skin_header_logo_light)
    _skin_header_logo_light.src = headerLogoLight ? _logo_light : _logo;

  if (_skin_footer_dark_logo)
    _skin_footer_dark_logo.src = footerLogoLight
      ? _logo_white
      : publicUrlFor(`images/skins-logo/logo-skin-${skin}-ftr.png`);

  if (_skin_footer_light_logo) _skin_footer_light_logo.src = _logo;

  if (_skin_page_logo) _skin_page_logo.src = _logo;

  if (_skin_maintain_logo)
    _skin_maintain_logo.src = publicUrlFor(
      `images/skins-logo/mainten-logo-${skin}.png`
    );

  if (_skin_header_inner_logo_12)
    _skin_header_inner_logo_12.src = publicUrlFor("images/skins-logo/logo-all.png");

  if (_skin_header_inner_logo_15)
    _skin_header_inner_logo_15.src = publicUrlFor("images/skins-logo/logo-white.png");
}
